export const AUTHORITY_TYPES = {
  HOSPITAL : "HOSPITAL",
  ADMIN: "ADMIN",
  PATIENT : "PATIENT",
}